import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';

import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');



const RenderWpForm = () => {

const resturl=sessionStorage.getItem("RESTURL");
//var boolFetchingSads=false;

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});



const [tblapsnews, settblapsnews] = useState([]);
const [crit, setCrit] = useState({txt:'', verified:0});

const [dowait, setDowait] = useState({on:false});
const [dlwait, setDlwait] = useState({show:false});
const [modal, setModal] = useState({open:false});

const location = useLocation();


useEffect(() => {

const USERNAME = sessionStorage.getItem("USERNAME")??"";

if (USERNAME==""){
	navigate("/");
	return;
	}//end if

if (tblapsnews.length<1){
	gettblapsnews();
	}//end if
	
 },[]);

useEffect(() => {
	document.getElementsByName('txt')[0].focus();
	
 },[JSON.stringify(tblapsnews)]);





useEffect(() => {
		gettblapsnews();
 },[crit]);

function handleChange(e){
	
	const {name, value} = e.target;
	console.log("handleChange: "+name+", "+value);
	
	if (name=="verified")
		setCrit((prev)=>{
			return {...prev, verified:e.target.checked?1:0}
		});
	else
		setCrit((prev)=>{
			return {...prev, [name]:value}
		});
	
	
}//end if

function toggleModalsm() {
if (!document.querySelector(".modalsm"))
	return false;
	
const modalsm = document.querySelector(".modalsm");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");
const isopen=modalsm.classList.contains("show-modalsm");
setModal((prev)=>{return {...prev, open:isopen};})

if (document.querySelector(".close-button")){
	const closeButton = document.querySelector(".close-button");
	if(!closeButton.classList.contains('attached-listener')){
		closeButton.classList.add('attached-listener');
		closeButton.addEventListener("click", toggleModalsm);
		window.addEventListener("click", windowOnClick);
		}//end if
	}//end if
return false;
}//end func



function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");

if (event.target === modalsm) 
	toggleModalsm();
    
}//end func

async function gettblapsnews(){

const params = {
	USERNAME:sessionStorage.getItem("USERNAME")
	, crit:crit.txt.trim()
	, verified:crit.verified
	};
	
console.log('params: '+JSON.stringify( params));
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		
	settblapsnews([]);
	
  await fetch(resturl+'rarwpform/gettblapsnews',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettblapsnews(res) )
      .catch(err => console.log(err));

}//end func


function aftergettblapsnews(res){
if (res.length==undefined)
	return;
	
console.log('aftergettblapsnews, res.length: '+res.length);

let htmrows=[];
res.map((col, index) => {
	const APS_NEWS_ID=col['APS_NEWS_ID'];
	const trkey='tr_'+APS_NEWS_ID;
	//const rdkey='rd_'+appid;
	
	const htmrow=<tr key={trkey} valign="top" >
	<td align='right' >{index+1}&nbsp;&nbsp;</td>
	<td align='left' >{col['TC_STAMP']}</td>
	<td align='left' >{col['CATEG']}</td>
	<td align='left' >{col['TITLE']}</td>
	<td align='left' style={{paddingBottom:"16px"}} >{col['NEWS_ITEM']}</td>
	</tr>;
	htmrows.push(htmrow);
});

settblapsnews(htmrows);
}//end func




function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func




  return (
    <>

<p align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"24px"}} >APS Updates</p>	


	<table align='center' width="65%" border="0" style={{marginTop:"10px", marginBottom:"10px"}} >
	<tbody>
	<tr>
		<td align='left' >
			<a href="#" onClick={(e)=>{e.preventDefault(); navigate("/wpapps");}} ><img src="img/return.png" border="0" /> return to list</a>
		</td>
		<td align='left' >
			search criteria:
			&nbsp;<input name='txt' value={crit.txt} onChange={(e)=>{handleChange(e);}} onFocus={(e)=>{e.target.select();}} placeholder='search by name' />
		</td>
		<td align='center' >&nbsp;</td>
		
	</tr>
	</tbody>
	</table>

	
	
	<table align='center' className='customers' style={{width:"85%"}} >
	<thead>
	<tr>
		<th>#</th>
		<th>Date</th>
		<th>Category</th>
		<th>Title</th>
		<th>News Item</th>
		
	</tr>
	</thead>
	<tbody>
		{tblapsnews}
	</tbody>
	</table>

<div className="modalsm">
    <div className="modalsm-content">
        <span className="close-button"  >&times;</span>
        <div align='center' id='modalsmtext' >

			<table align='center'>
			<tbody>

			<tr>
			<td align='right' >Photo Path: </td>
			<td align='left' ><input name='PHOTO_PATH'  readOnly className="gnsbro"  onFocus={(e)=>{e.target.select();}}  autoComplete='off' /></td>
			</tr>

			<tr>
			<td align='right' >&nbsp;</td>
			<td align='left' >
			{dowait.on && <div><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</div>}
			{!dowait.on && <button className="button" id='btnupdate' onClick={(e)=>{}} >save changes</button>}
			</td>
			</tr>		
			</tbody>
			</table>
		
		</div>
    </div>
</div>
<div id="snackbar">&nbsp;</div>


    </>
  );
  


};


export default RenderWpForm;